import { triplaServer } from 'src/apis/server'
import { appendParams } from 'src/javascript/Utilities/paramsSerialize'

export default {
  getBrrWidgetSetting(hotelCode) {
    return triplaServer
      .get(`hotels/${hotelCode}/settings/brr_widget`, {
        headers: {
          'App-Version': 'tripla-booking-widget/1.0',
          'client-session': sessionStorage.getItem('triplabot_client_session')
        }
      })
      .then((res) => res.data)
  },
  getOtaPrice(hotelId, payload = {}) {
    const serialized = appendParams(payload)
    return triplaServer
      .get(`hotels/${hotelId}/rooms?${serialized}`, {
        headers: {
          'App-Version': 'tripla-booking-widget/1.0',
          'client-session': sessionStorage.getItem('triplabot_client_session')
        },
        withAuthorizationHeader: false
      })
      .then((res) => res.data)
  }
}
